<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.333 29.276">
  <path d="M6.912 29.276a2.225 2.225 0 01-2.227-2.155l-.072-2.366C1.64 22.093 0 18.357 0 14.235c0-3.936 1.51-7.555 4.255-10.19C6.97 1.437 10.668 0 14.667 0c3.998 0 7.696 1.437 10.412 4.045 2.744 2.635 4.254 6.254 4.254 10.19 0 3.934-1.51 7.553-4.254 10.189-2.716 2.607-6.414 4.044-10.412 4.044-1.442 0-2.852-.187-4.194-.553l-2.662 1.172a2.23 2.23 0 01-.899.189zm7.754-26.988c-7.054 0-12.374 5.136-12.374 11.947 0 3.468 1.372 6.604 3.864 8.829.46.413.724.973.746 1.579v.015l.071 2.305 2.595-1.143a2.235 2.235 0 011.485-.11 13.61 13.61 0 003.613.477c7.055 0 12.375-5.136 12.375-11.945 0-6.811-5.32-11.947-12.375-11.947zm-7.21 16.617l4.282-3.294a.814.814 0 01.98 0l3.168 2.458c.95.707 2.31.458 2.943-.54l3.983-6.304c.384-.601-.363-1.281-.934-.85l-4.28 3.237a.812.812 0 01-.98 0L13.45 11.21a2.047 2.047 0 00-2.943.54l-3.984 6.304c-.385.6.363 1.282.934.85z"/>
</svg>
</template>

<script>
export default {

}
</script>
